// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"12":"profiler","777":"recorder"}[chunkId] + "." + {"12":"a7f931396b4df6c209b2","777":"1822493a768507d06e5f"}[chunkId] + ".chunk.js";
};